module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_right.d0748257.svg";